<!-- eslint-disable vue/no-v-html -->
<template>
	<div class="animated fadeIn">
		<div class="table-responsive">
			<table class="table table-hover table-striped text-nowrap">
				<thead>
					<tr>
						<th
							class="border-top-0">
							{{ translate('item') }}
						</th>
						<th
							class="border-top-0 text-right pr-5">
							{{ translate('total') }}
						</th>
					</tr>
				</thead>
				<tbody v-if="!loading && hasData">
					<template v-for="(item) in data">
						<tr
							:key="item.key"
							:class="{ 'pointer': true }"
							@click="handleParentOrderClick(item)">
							<td class="align-middle">
								<b><i :class="`fas fa-chevron-${expanded[item.key] ? 'down' : 'right'}`" /></b>
								{{ translate(item.key) }}
							</td>
							<td
								class="align-middle text-right pr-5">
								{{ item.value }} <em>{{ translate('orders') }}</em>
							</td>
						</tr>
						<template v-if="expanded[item.key]">
							<tr
								v-for="(product) in item.products"
								:key="`${item.key}-${product.sku}`">
								<td class="align-middle">
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ product.name }}
								</td>
								<td class="align-middle text-right pr-5">
									{{ Number.parseInt(product.total_qty) }} <em>{{ translate('items') }}</em>
								</td>
							</tr>
						</template>
					</template>
				</tbody>
			</table>
		</div>
		<is-loading
			:loading-label="translate('loading')"
			:no-data-label="translate('data_not_found')"
			:loading="loading"
			:has-data="hasData" />
	</div>
</template>
<script>

import {
	Grids, Order as OrderTranslations, OrdersDetails,
} from '@/translations';
import DashboardRedirect from '@/mixins/DashboardRedirect';
import Order from '@/util/Order';
import { admin } from '@/settings/Roles';
import Country from '@/util/Country';
import WindowSizes from '@/mixins/WindowSizes';

export default {
	name: 'PickupOrdersSummary',
	messages: [
		Grids, OrderTranslations, OrdersDetails,
	],
	mixins: [DashboardRedirect, WindowSizes],
	data() {
		return {
			orders: new Order(),
			countryData: new Country(),
			admin,
			expanded: {},
		};
	},
	computed: {
		loading() {
			return !!this.orders.data.loading;
		},
		pagination() {
			return this.orders.data.pagination;
		},
		data() {
			try {
				const { data } = this.orders.data.response;
				return data;
			} catch (error) {
				return [];
			}
		},
		hasData() {
			try {
				const response = this.data.length;
				return !!response;
			} catch (error) {
				return false;
			}
		},
		countries() {
			try {
				return this.countryData.data.response.data.data;
			} catch (error) {
				return [];
			}
		},
		showCountryFilter() {
			return this.admin.includes(this.$user.details().type);
		},
		staffCountry() {
			if (this.admin.includes(this.$user.details().type)) {
				return this.$user.details().country !== undefined;
			}
			return false;
		},
		countryCode() {
			return this.$user.details().country.iso_code_2;
		},
	},
	mounted() {
		this.getOrders();
	},
	methods: {
		getOrders() {
			if (this.$route.params.distributorId) this.$route.query.userId = this.$route.params.distributorId;

			this.orders.getPickUpOrdersSummary();

			this.countryData.getReportCountries({ also_pickup_stores: true });
			if (this.showCountryFilter) {
				if (this.staffCountry) {
					this.filters.country = this.countryCode;
				}
			}
		},
		handleParentOrderClick(item) {
			this.$set(this.expanded, item.key, !this.expanded[item.key]);
		},
	},
};
</script>
